import { request } from '@/shared/api/request'

export const rejectTradeUnion = (params) => {
	return request({ url: `colcontract/tradeUnion/rejectTradeUnion/${params}`, method: 'POST' })
}